import { ROUTE_STORE_FULL_URL } from '@src/constants/URLS.const';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as EsimEmptyImage } from '@src/assets/images/Esim.svg';
import { ReactComponent as EsimEmptyImageDark } from '@src/assets/images/EsimDark.svg';
import React from 'react';
import { RootState } from '@src/store/store';
import { useSelector } from 'react-redux';
import { THEME } from '@src/store/layout/layoutSlice';
import { Button } from 'antd';

export function EmptyList({ image }: { image?: React.ReactNode }) {
  const theme = useSelector((state: RootState) => state.layout.theme);

  const navigate = useNavigate();

  return (
    <div className='flex justify-center'>
      <div className='flex flex-col items-center w-[400px] gap-4'>
        {image ? (
          image
        ) : theme === THEME.LIGHT ? (
          <EsimEmptyImage className='w-full max-h-[200]' />
        ) : (
          <EsimEmptyImageDark className='w-full max-h-[200]' />
        )}
        <p className='text-wl-on-background text-center text-M-18 sm:px-10'>
          Explore Esimora and active your eSIM today!
        </p>

        <Button
          className='btn-primary w-full'
          size='large'
          onClick={() => navigate(ROUTE_STORE_FULL_URL)}
        >
          <p className='text-wl-on-primary'>Explore eSIMs</p>
        </Button>
      </div>
    </div>
  );
}
